// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown-module-dropdown {
  background-color: var(--popup-background);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  box-sizing: border-box;
  max-width: 360px;
}

.Dropdown-module-dropdownContainer {
  display: flex;
  align-items: center;
}

.Dropdown-module-toggleButton > span {
  align-items: center;
  display: flex;
  gap: 10px;
}

.Dropdown-module-dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.Dropdown-module-dropdown li button {
  width: 100%;
  border-radius: 0;
  display: flex;
  justify-content: space-between;
}

.Dropdown-module-dropdown li:first-of-type button {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.Dropdown-module-dropdown li:last-of-type button {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.Dropdown-module-dropdownBackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: var(--popup-container-background);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

@media screen and (min-width: 380px) {

  .Dropdown-module-dropdownBackground {
    background-color: transparent;
    width: auto;
    height: auto;
    left: var(--dropdown-left-offset); /* Defined by Dropdown.tsx */
    top: var(--dropdown-top-offset); /* Defined by Dropdown.tsx */
  }

  .Dropdown-module-dropdown {
    border-radius: 5px;
    padding: 5px;
    min-width: 200px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }

  .Dropdown-module-dropdown li button {
    background-color: transparent;
    box-shadow: none;
    border-radius: 5px;
  }

  .Dropdown-module-dropdown li button:hover {
    background-color: var(--secondary-button-background);
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  }

  .Dropdown-module-dropdownTitle {
    display: none;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mDAAmD;EACnD,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE;IACE,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,iCAAiC,EAAE,4BAA4B;IAC/D,+BAA+B,EAAE,4BAA4B;EAC/D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,uFAAuF;EACzF;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oDAAoD;IACpD,uFAAuF;EACzF;;EAEA;IACE,aAAa;EACf;;AAEF","sourcesContent":[".dropdown {\r\n  background-color: var(--popup-background);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 15px;\r\n  padding: 15px;\r\n  border-top-left-radius: 5px;\r\n  border-top-right-radius: 5px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  max-width: 360px;\r\n}\r\n\r\n.dropdownContainer {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.toggleButton > span {\r\n  align-items: center;\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.dropdown ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.dropdown li button {\r\n  width: 100%;\r\n  border-radius: 0;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.dropdown li:first-of-type button {\r\n  border-top-left-radius: 5px;\r\n  border-top-right-radius: 5px;\r\n}\r\n\r\n.dropdown li:last-of-type button {\r\n  border-bottom-left-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n\r\n.dropdownBackground {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1;\r\n  background-color: var(--popup-container-background);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n}\r\n\r\n@media screen and (min-width: 380px) {\r\n\r\n  .dropdownBackground {\r\n    background-color: transparent;\r\n    width: auto;\r\n    height: auto;\r\n    left: var(--dropdown-left-offset); /* Defined by Dropdown.tsx */\r\n    top: var(--dropdown-top-offset); /* Defined by Dropdown.tsx */\r\n  }\r\n\r\n  .dropdown {\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    min-width: 200px;\r\n    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\r\n  }\r\n\r\n  .dropdown li button {\r\n    background-color: transparent;\r\n    box-shadow: none;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .dropdown li button:hover {\r\n    background-color: var(--secondary-button-background);\r\n    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\r\n  }\r\n\r\n  .dropdownTitle {\r\n    display: none;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var dropdown = `Dropdown-module-dropdown`;
export var dropdownContainer = `Dropdown-module-dropdownContainer`;
export var toggleButton = `Dropdown-module-toggleButton`;
export var dropdownBackground = `Dropdown-module-dropdownBackground`;
export var dropdownTitle = `Dropdown-module-dropdownTitle`;
export default ___CSS_LOADER_EXPORT___;
